import {
    Navigate,
    Outlet,
} from 'react-router-dom'
import Loggers from 'app/Apps/LoggersAndGateways/Loggers'
import {
    createSkyNetRoutes,
} from 'app/SkyNetRoutes'

import {
    App,
} from 'app/enums/domain.enums'

import Dashboard from 'app/common/Dashboard'
import Finance from 'app/Apps/Finance'
import Pricing from 'app/Apps/Pricing'
import Deployments from 'app/Apps/LoggersAndGateways/Deployments'
import TransportPlanner from 'app/Apps/TransportPlanner'
import Gateways from 'app/Apps/LoggersAndGateways/Gateways'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import ContactManagement from './ContactManagement'
import OrderManagement from './OrderManagement'
import AccountManagement from './AccountManagement'
import Forecast from './Forecast'
import Rates from './Rates'
import DamageTracking from './DamageTracking'
import RelationshipsManagement from './RelationshipsManagement'
import ContainerManagement from './ContainerManagement'

export default {
    [App.Dashboard]: <Dashboard />,
    [App.OrderManagement]: <OrderManagement />,
    [App.Containers]: <ContainerManagement />,
    [App.Finance]: <Finance />,
    [App.Gateways]: <Gateways />,
    [App.AccountManagement]: {
        element: <Outlet />,
        children: createSkyNetRoutes({
            routesConfig: AccountManagement,
        }),
    },
    [App.Pricing]: <Pricing />,
    [App.Deployments]: <Deployments />,
    [App.Loggers]: <Loggers />,
    [App.ContactManagement]: <ContactManagement />,
    [App.RelationshipsManagement]: <RelationshipsManagement />,
    [App.TransportPlanner]: <TransportPlanner />,
    [App.DamageTracking]: <DamageTracking />,
    [App.Forecast]: <Forecast />,
    [App.Rates]: <Rates />,
    [CommonRoutes.Asterisk]: <Navigate
        to={App.Dashboard}
        replace
    />,
}
